export default function PostCodeError(props) {
  return (
    <>
      <p className="customError">{props.error}</p>
    </>
  );
}
